// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-1Xxapt-M clearfix","box":"box-3jucMaVY"};